import { render } from "./zimskeLige.vue?vue&type=template&id=fb649c32&scoped=true"
import script from "./zimskeLige.vue?vue&type=script&lang=js"
export * from "./zimskeLige.vue?vue&type=script&lang=js"

import "./zimskeLige.vue?vue&type=style&index=0&id=fb649c32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb649c32"]])

export default __exports__